import { ReduxState } from 'src/store/types';

export const pendingAutoGenerateMockDataSelector =
  (projectId: string) =>
  (state: ReduxState): boolean | undefined =>
    state.projects.pendingAutoGenerateMockDataByProjectId[projectId];

export const hasPendingAutoGenerateMockDataSelector = (
  state: ReduxState
): boolean =>
  Object.keys(state.projects.pendingAutoGenerateMockDataByProjectId).length > 0;
